 const ProductUploadLoader = () => (
    <div className="min-h-screen pb-20 animate-pulse">
      {/* Header Skeleton */}
      <div className=" flex justify-between items-center">
        <div className="flex items-center gap-4">
          <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
          <div className="w-48 h-8 bg-gray-200 rounded-lg"></div>
        </div>
        <div className="flex gap-3">
          <div className="w-28 h-10 bg-gray-200 rounded-lg"></div>
          <div className="w-28 h-10 bg-gray-200 rounded-lg"></div>
        </div>
      </div>

      <div className="py-4 md:py-6 grid grid-cols-1 lg:grid-cols-12 gap-6">
        {/* Left Sidebar Skeleton */}
        <div className="lg:col-span-3 space-y-6">
          {[1, 2, 3].map((i) => (
            <div key={i} className="bg-white p-5 rounded-xl border border-gray-100 space-y-4">
              <div className="w-24 h-4 bg-gray-200 rounded mb-4"></div>
              <div className="w-full h-10 bg-gray-100 rounded-lg"></div>
              <div className="w-full h-24 bg-gray-100 rounded-lg"></div>
              <div className="w-full h-10 bg-gray-100 rounded-lg"></div>
            </div>
          ))}
        </div>

        {/* Main Content Skeleton */}
        <div className="lg:col-span-9 space-y-6">
          <div className="bg-white p-6 rounded-xl border border-gray-100 space-y-8">
            <div className="flex justify-between">
              <div className="w-64 h-12 bg-gray-100 rounded-lg"></div>
              <div className="w-10 h-10 bg-gray-100 rounded-full"></div>
            </div>
            <div className="flex gap-4">
              {[1, 2, 3, 4].map(i => <div key={i} className="w-20 h-24 bg-gray-100 rounded-lg"></div>)}
            </div>
            <div className="space-y-3">
              <div className="w-full h-12 bg-gray-50 rounded-lg"></div>
              <div className="w-full h-12 bg-gray-50 rounded-lg"></div>
              <div className="w-full h-12 bg-gray-50 rounded-lg"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

export default ProductUploadLoader;